import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core'
import { MatGridListModule } from '@angular/material/grid-list'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { PlayerService } from '../../core/services/player.service'
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator'
import { MatSort, MatSortModule, Sort } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { AtletiPlayer } from '../../core/models/atleti-player.model'
import { MatIconModule } from '@angular/material/icon'
import { LiveAnnouncer } from '@angular/cdk/a11y'
import { MatCardModule } from '@angular/material/card'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { AuthService } from '../../core/services/auth.service'
import { SearchPlayerDialog } from '../players/search-player/search-player.component'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { SnackbarService } from 'src/app/core/services/snackbar.service'

@Component({
  selector: 'atleti-team-component',
  templateUrl: 'atleti-team.component.html',
  standalone: true,
  imports: [
    MatGridListModule,
    CommonModule,
    RouterModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatPaginatorModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  styleUrl: './atleti-team.component.css'
})
export class AtletiTeamComponent implements AfterViewInit {
  constructor(
    public auth: AuthService,
    public service: PlayerService, 
    public dialog: MatDialog, 
    private snackbar: SnackbarService,
    private _liveAnnouncer: LiveAnnouncer
  ){}

  seasons: string[] = ['2025/2026','2024/2025','2023/2024']
  displayedColumns: string[] = ["name", "nation", "age", "actions"]
  dataSource!: MatTableDataSource<AtletiPlayer, MatPaginator>

  @ViewChild(MatSort) sort!: MatSort
  @ViewChild(MatPaginator) paginator!: MatPaginator

  ngAfterViewInit() {
    //Load scores data
    this.service.playerAtletiForm.get('season')?.setValue('2025/2026')
    this.reloadData()

    this.service.playerAtletiForm.get('season')?.valueChanges.subscribe(()=>this.reloadData())
  }

  reloadData(){
    const season = this.service.playerAtletiForm.get('season')?.value ?? '2025/2026'
    this.service.fetchPlayerSquad(season,'66969b1f21b3dbe997311819')
    .subscribe(response => {
      this.dataSource = new MatTableDataSource(response as AtletiPlayer[])
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`)
    else this._liveAnnouncer.announce('Sorting cleared')
  }

  populateForm(p:AtletiPlayer){
    this.service.playerAtletiForm.patchValue(p)
  }

  onDelete(_id: string){
    if(confirm('Are you sure to delete this record?')){
      this.service.deletePlayerFromTeam(_id, '66969b1f21b3dbe997311819').subscribe(res=>{
        this.service.playerAtletiForm.get('player._id')?.setValue(null)
        this.snackbar.showSnackbar('Successfully deleted!')
        this.reloadData()
      })
    }
  }

  onAddPlayer(){
    const dialogRef = this.dialog.open(SearchPlayerDialog, {width: '50vw'})
    dialogRef.afterClosed().subscribe(()=> {
      this.reloadData()
    })
  }

  displayFn(date: Date){
    let timeDiff = Math.abs(Date.now() - new Date(date).getTime())
    return Math.floor((timeDiff / (1000 * 3600 * 24))/365.25)
  }
}